import { Navigate, useParams } from "react-router-dom";

/** Homepage path for a retired `/menu-browse` visit (legacy `/` or alias `/r/:slug`). */
export function menuBrowseRedirectTarget(slug?: string): string {
  const trimmed = slug?.trim() ?? "";
  return trimmed ? `/r/${trimmed}` : "/";
}

/**
 * Replaces the retired menu-browse page with the tenant homepage.
 * `replace` keeps history clean so Back does not return to the dead URL.
 */
export default function LegacyMenuBrowseRedirect() {
  const { slug } = useParams();
  return <Navigate to={menuBrowseRedirectTarget(slug)} replace />;
}
